import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import Amplify from 'aws-amplify';
import P3ConfigurationExportPage from 'views/pages/P3ConfigurationsExport/P3ConfigurationExport';
import { AuthProvider, AuthConsumer } from 'services/ThomasAuth/AuthContext';
import App from 'views/pages/App/App';
import { client } from 'services/ApolloClient/Client';
import { Switch, Route } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import Logout from 'views/components/Login/Logout';
import NoAuthorizedPage from 'views/components/Access/NoAuthorizedPage';
import KeepSessionPage from 'views/components/Access/KeepSessionPage';
import HomePage from 'views/pages/Home/Home';
import LoginPage from 'views/pages/Login/Login';

const BASE_URL_PATH = process.env.REACT_APP_BASE_URL_PATH
  ? process.env.REACT_APP_BASE_URL_PATH
  : '/';
Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_COGNITO_USERPOOL_ID || 'us-east-1_usWhmS6wE',

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId:
      process.env.REACT_APP_COGNITO_USERPOOL_WEBCLIENT_ID || 'a6bmsdij8qr0egi7tgs09pkum',

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: false,

    oauth: {
      domain:
        process.env.REACT_APP_COGNITO_DOMAIN || 'test-thomas-auth.auth.us-east-1.amazoncognito.com',
      scope: ['email', 'profile', 'openid'],
      redirectSignIn: process.env.REACT_APP_COGNITO_SIGNIN || 'https://localhost:3000/login',
      redirectSignOut: process.env.REACT_APP_COGNITO_SIGNOUT || 'https://localhost:3000/login',
      responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
    }
  }
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <AuthProvider>
      <AuthConsumer>
        {auth => (
          <BrowserRouter basename={BASE_URL_PATH}>
            <Switch>
              <Route
                path="/keep-session"
                exact
                render={props => <KeepSessionPage authContext={auth.auth} {...props} />}
              />
              <Route
                path="/config-export/:configurationId/:tgramsId/:campaignId"
                exact
                render={props => <P3ConfigurationExportPage {...props} />}
              />
              <Route
                path="/config-export/:configurationId/:tgramsId"
                exact
                render={props => <P3ConfigurationExportPage {...props} />}
              />
              <Route
                path="/config-export/:configurationId"
                exact
                render={props => <P3ConfigurationExportPage {...props} />}
              />
              <Route path="/noauthorized" render={props => <NoAuthorizedPage {...props} />} />
              <Route
                path="/logout"
                exact
                render={props => <Logout auth={auth.auth} {...props} />}
              />
              <Route
                path="/"
                exact
                render={props => <HomePage authContext={auth.auth} {...props} />}
              />
              <Route path="/login" exact render={props => <LoginPage />} />
              <Route render={props => <App authContext={auth.auth} {...props} client={client} />} />
            </Switch>
          </BrowserRouter>
        )}
      </AuthConsumer>
    </AuthProvider>
  </ApolloProvider>,
  document.getElementById('root')
);
